import { useEffect, useRef, useState } from 'react';

import { displayFormattedTime } from '../helpers';
import { CallDurationProps } from '../types';

const CallDuration: React.FC<CallDurationProps> = ({ startTimer }) => {
    const [duration, setDuration] = useState(0);
    const intervalId = useRef<NodeJS.Timer | null>(null);

    useEffect(() => {
        if (startTimer && !intervalId.current)
            intervalId.current = setInterval(() => setDuration((prevVal) => prevVal + 1), 1000);

        if (!startTimer && intervalId.current) clearInterval(intervalId.current);

        return () => {
            if (intervalId.current !== null) clearInterval(intervalId.current);
        };
    }, [startTimer]);

    const className = !startTimer ? 'text-white text-opacity-40' : '';

    return <span className={className}>{displayFormattedTime(duration)}</span>;
};
export default CallDuration;
